import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  tabsRoot: {
    width: '100% !important',
  },
  mainContainer: {
    width: '100%',
    padding: '1rem',
  },
}));

export default useStyles;
